export const formatQuantity = (quantity) => {
  const value = Number(quantity ?? 0);
  return Number.isFinite(value)
    ? value.toLocaleString("en-IN", { maximumFractionDigits: 3 })
    : "-";
};
